"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const form_field_types_1 = require("@App/enum/form-field-types");
const Status_1 = __importDefault(require("@Components/Status"));
const suggestion_status_1 = require("@Components/MatchComponents/v2/suggestion-status");
const react_1 = __importDefault(require("react"));
const FilterSection_1 = __importDefault(require("@Components/Search/SearchWithCriteria/FilterSection"));
const SubmissionFilters = (props) => {
    const submissionFilters = [
        {
            name: 'Submission Status Filter',
            allowMultiple: false,
            filterFields: [
                {
                    SUBMITTED: {
                        type: form_field_types_1.FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'SUBMITTED',
                        label: '',
                        children: react_1.default.createElement(Status_1.default, { withCount: false, status: suggestion_status_1.SUGGESTION_STATUS_VALUES.SUBMITTED, big: true }),
                        rounded: true,
                    },
                },
                {
                    ACCEPTED: {
                        type: form_field_types_1.FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'ACCEPTED',
                        label: '',
                        children: react_1.default.createElement(Status_1.default, { withCount: false, status: suggestion_status_1.SUGGESTION_STATUS_VALUES.ACCEPTED, big: true }),
                        rounded: true,
                    },
                },
                {
                    PARTIALLY_ACCEPTED: {
                        type: form_field_types_1.FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'PARTIALLY_ACCEPTED',
                        label: '',
                        children: (react_1.default.createElement(Status_1.default, { withCount: false, status: suggestion_status_1.SUGGESTION_STATUS_VALUES.PARTIALLY_ACCEPTED, big: true })),
                        rounded: true,
                    },
                },
                {
                    REJECTED: {
                        type: form_field_types_1.FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'REJECTED',
                        label: '',
                        children: react_1.default.createElement(Status_1.default, { withCount: false, status: suggestion_status_1.SUGGESTION_STATUS_VALUES.REJECTED, big: true }),
                        rounded: true,
                    },
                },
                {
                    IN_PROGRESS: {
                        type: form_field_types_1.FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'IN_PROGRESS',
                        label: '',
                        children: (react_1.default.createElement(Status_1.default, { withCount: false, status: suggestion_status_1.SUGGESTION_STATUS_VALUES.IN_PROGRESS, big: true })),
                        rounded: true,
                    },
                },
                {
                    SUPERSEDED: {
                        type: form_field_types_1.FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'SUPERSEDED',
                        label: '',
                        children: (react_1.default.createElement(Status_1.default, { withCount: false, status: suggestion_status_1.SUGGESTION_STATUS_VALUES.SUPERSEDED, big: true })),
                        rounded: true,
                    },
                },
            ],
        },
        {
            name: 'Sort',
            allowMultiple: false,
            filterFields: [
                {
                    SORT: {
                        type: form_field_types_1.FormFieldTypes.RADIO,
                        options: [
                            { name: 'submission_timestamp', label: 'Submission Date', default: true },
                            { name: 'last_updated_date', default: true, label: 'Last Updated' },
                        ],
                        name: 'SORT_BY',
                        label: '',
                    },
                },
            ],
        },
    ];
    return react_1.default.createElement(FilterSection_1.default, Object.assign({}, props, { filterCollections: submissionFilters }));
};
exports.default = SubmissionFilters;
